export const getUrlProjectSettings = () => {
  const matchParams = window.location.pathname.match(/\/([A-Z][A-Z-0-9]+)(:?\/([A-Z][A-Z-0-9]+))?/);

  return matchParams ? { spaceKey: matchParams[1] ?? null, projectKey: matchParams[3] ?? null } : { spaceKey: null, projectKey: null };
};
